import { render, staticRenderFns } from "./MemberLiaison.vue?vue&type=template&id=5e8c46d4&"
import script from "./MemberLiaison.vue?vue&type=script&lang=js&"
export * from "./MemberLiaison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports